export enum I18nLocale {
  EN = 'en',
  ES = 'es',
  PT = 'pt',
}

export const I18N_LOCALES = [I18nLocale.EN, I18nLocale.ES, I18nLocale.PT];
